import { render, staticRenderFns } from "./ViewTitle.vue?vue&type=template&id=67baab07&scoped=true"
import script from "./ViewTitle.vue?vue&type=script&lang=js"
export * from "./ViewTitle.vue?vue&type=script&lang=js"
import style0 from "./ViewTitle.vue?vue&type=style&index=0&id=67baab07&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67baab07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67baab07')) {
      api.createRecord('67baab07', component.options)
    } else {
      api.reload('67baab07', component.options)
    }
    module.hot.accept("./ViewTitle.vue?vue&type=template&id=67baab07&scoped=true", function () {
      api.rerender('67baab07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/ViewTitle.vue"
export default component.exports